var map = {
	"./affix/style/index.ts": "./components/affix/style/index.ts",
	"./alert/style/index.ts": "./components/alert/style/index.ts",
	"./anchor/style/index.ts": "./components/anchor/style/index.ts",
	"./app/style/index.ts": "./components/app/style/index.ts",
	"./avatar/style/index.ts": "./components/avatar/style/index.ts",
	"./back-top/style/index.ts": "./components/back-top/style/index.ts",
	"./badge/style/index.ts": "./components/badge/style/index.ts",
	"./border-beam/style/index.ts": "./components/border-beam/style/index.ts",
	"./breadcrumb/style/index.ts": "./components/breadcrumb/style/index.ts",
	"./button/style/index.ts": "./components/button/style/index.ts",
	"./calendar/style/index.ts": "./components/calendar/style/index.ts",
	"./card/style/index.ts": "./components/card/style/index.ts",
	"./carousel/style/index.ts": "./components/carousel/style/index.ts",
	"./cascader/style/index.ts": "./components/cascader/style/index.ts",
	"./checkbox/style/index.ts": "./components/checkbox/style/index.ts",
	"./col/style/index.ts": "./components/col/style/index.ts",
	"./collapse/style/index.ts": "./components/collapse/style/index.ts",
	"./color-picker/style/index.ts": "./components/color-picker/style/index.ts",
	"./config-provider/style/index.ts": "./components/config-provider/style/index.ts",
	"./date-picker/style/index.ts": "./components/date-picker/style/index.ts",
	"./descriptions/style/index.ts": "./components/descriptions/style/index.ts",
	"./divider/style/index.ts": "./components/divider/style/index.ts",
	"./drawer/style/index.ts": "./components/drawer/style/index.ts",
	"./dropdown/style/index.ts": "./components/dropdown/style/index.ts",
	"./empty/style/index.ts": "./components/empty/style/index.ts",
	"./flex/style/index.ts": "./components/flex/style/index.ts",
	"./float-button/style/index.ts": "./components/float-button/style/index.ts",
	"./form/style/index.ts": "./components/form/style/index.ts",
	"./grid/style/index.ts": "./components/grid/style/index.ts",
	"./image/style/index.ts": "./components/image/style/index.ts",
	"./input-number/style/index.ts": "./components/input-number/style/index.ts",
	"./input/style/index.ts": "./components/input/style/index.ts",
	"./layout/style/index.ts": "./components/layout/style/index.ts",
	"./list/style/index.ts": "./components/list/style/index.ts",
	"./masonry/style/index.ts": "./components/masonry/style/index.ts",
	"./mentions/style/index.ts": "./components/mentions/style/index.ts",
	"./menu/style/index.ts": "./components/menu/style/index.ts",
	"./message/style/index.ts": "./components/message/style/index.ts",
	"./modal/style/index.ts": "./components/modal/style/index.ts",
	"./notification/style/index.ts": "./components/notification/style/index.ts",
	"./pagination/style/index.ts": "./components/pagination/style/index.ts",
	"./popconfirm/style/index.ts": "./components/popconfirm/style/index.ts",
	"./popover/style/index.ts": "./components/popover/style/index.ts",
	"./progress/style/index.ts": "./components/progress/style/index.ts",
	"./qr-code/style/index.ts": "./components/qr-code/style/index.ts",
	"./qrcode/style/index.ts": "./components/qrcode/style/index.ts",
	"./radio/style/index.ts": "./components/radio/style/index.ts",
	"./rate/style/index.ts": "./components/rate/style/index.ts",
	"./result/style/index.ts": "./components/result/style/index.ts",
	"./row/style/index.ts": "./components/row/style/index.ts",
	"./segmented/style/index.ts": "./components/segmented/style/index.ts",
	"./select/style/index.ts": "./components/select/style/index.ts",
	"./skeleton/style/index.ts": "./components/skeleton/style/index.ts",
	"./slider/style/index.ts": "./components/slider/style/index.ts",
	"./space/style/index.ts": "./components/space/style/index.ts",
	"./spin/style/index.ts": "./components/spin/style/index.ts",
	"./splitter/style/index.ts": "./components/splitter/style/index.ts",
	"./statistic/style/index.ts": "./components/statistic/style/index.ts",
	"./steps/style/index.ts": "./components/steps/style/index.ts",
	"./switch/style/index.ts": "./components/switch/style/index.ts",
	"./table/style/index.ts": "./components/table/style/index.ts",
	"./tabs/style/index.ts": "./components/tabs/style/index.ts",
	"./tag/style/index.ts": "./components/tag/style/index.ts",
	"./timeline/style/index.ts": "./components/timeline/style/index.ts",
	"./tooltip/style/index.ts": "./components/tooltip/style/index.ts",
	"./tour/style/index.ts": "./components/tour/style/index.ts",
	"./transfer/style/index.ts": "./components/transfer/style/index.ts",
	"./tree-select/style/index.ts": "./components/tree-select/style/index.ts",
	"./tree/style/index.ts": "./components/tree/style/index.ts",
	"./typography/style/index.ts": "./components/typography/style/index.ts",
	"./upload/style/index.ts": "./components/upload/style/index.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/[^_][\\w-]+\\/style\\/index\\.tsx%3F$";